import { Controller } from "stimulus"
import {Turbo} from "@hotwired/turbo-rails";
window.Turbo = Turbo

export default class extends Controller {
  static targets = [ "entries" ]

  connect() {
    // console.log('connected');
  }

  onBeforeDelete(e) {
    this.elementToDelete = e.currentTarget.closest('li')
  }

  onDelete(e) {
    const [data, status, xhr] = e.detail;

    if (this.elementToDelete) {
      this.elementToDelete.remove()
      this.elementToDelete = null
    }

    if (this.branches === 1) {
      let li = this.entriesTarget.getElementsByTagName("li")[0]
      if (li != null){
        li.getElementsByTagName('a')[0].remove()
      }
    }
  }

  onEditClick(e) {
    const li = e.currentTarget.closest('li')
    li.querySelector('.branch-name-display').classList.add('hidden')
    li.querySelector('.branch-edit-btn').classList.add('hidden')
    const editForm = li.querySelector('.branch-edit-form')
    editForm.classList.remove('hidden')
    editForm.classList.add('flex')
    editForm.querySelector('.branch-name-input').focus()
  }

  onEditCancel(e) {
    const li = e.currentTarget.closest('li')
    li.querySelector('.branch-edit-form').classList.add('hidden')
    li.querySelector('.branch-edit-form').classList.remove('flex')
    li.querySelector('.branch-name-display').classList.remove('hidden')
    li.querySelector('.branch-edit-btn').classList.remove('hidden')
  }

  async onEditSave(e) {
    const btn = e.currentTarget
    const li = btn.closest('li')
    const branchCode = btn.dataset.branchCode
    const input = li.querySelector('.branch-name-input')
    const newName = input.value.trim()

    if (!newName) return

    btn.disabled = true

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')
      const response = await fetch(`/admin/${branchCode}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          ...(csrfToken ? { 'X-CSRF-Token': csrfToken.content } : {})
        },
        body: JSON.stringify({ nombre: newName })
      })

      if (response.ok) {
        const data = await response.json()
        const displaySpan = li.querySelector('.branch-name-display')
        displaySpan.textContent = `${data.nombre} (${branchCode})`
        this._closeEditForm(li)
      } else {
        alert('Error al guardar el nombre de la sucursal.')
      }
    } catch (err) {
      alert('Error de red al guardar.')
    } finally {
      btn.disabled = false
    }
  }

  onCommerceEditClick(e) {
    const dd = e.currentTarget.closest('dd')
    dd.querySelector('.commerce-name-display').classList.add('hidden')
    dd.querySelector('.commerce-edit-btn').classList.add('hidden')
    const editForm = dd.querySelector('.commerce-edit-form')
    editForm.classList.remove('hidden')
    editForm.classList.add('flex')
    editForm.querySelector('.commerce-name-input').focus()
  }

  onCommerceEditCancel(e) {
    const dd = e.currentTarget.closest('dd')
    dd.querySelector('.commerce-edit-form').classList.add('hidden')
    dd.querySelector('.commerce-edit-form').classList.remove('flex')
    dd.querySelector('.commerce-name-display').classList.remove('hidden')
    dd.querySelector('.commerce-edit-btn').classList.remove('hidden')
  }

  async onCommerceEditSave(e) {
    const btn = e.currentTarget
    const dd = btn.closest('dd')
    const commerceId = btn.dataset.commerceId
    const input = dd.querySelector('.commerce-name-input')
    const newName = input.value.trim()

    if (!newName) return

    btn.disabled = true

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')
      const response = await fetch(`/admin/commerce/${commerceId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          ...(csrfToken ? { 'X-CSRF-Token': csrfToken.content } : {})
        },
        body: JSON.stringify({ nombre: newName })
      })

      if (response.ok) {
        const data = await response.json()
        dd.querySelector('.commerce-name-display').textContent = data.nombre
        input.value = data.nombre
        this._closeCommerceEditForm(dd)
      } else {
        alert('Error al guardar el nombre del comercio.')
      }
    } catch (err) {
      alert('Error de red al guardar.')
    } finally {
      btn.disabled = false
    }
  }

  _closeCommerceEditForm(dd) {
    dd.querySelector('.commerce-edit-form').classList.add('hidden')
    dd.querySelector('.commerce-edit-form').classList.remove('flex')
    dd.querySelector('.commerce-name-display').classList.remove('hidden')
    dd.querySelector('.commerce-edit-btn').classList.remove('hidden')
  }

  _closeEditForm(li) {
    li.querySelector('.branch-edit-form').classList.add('hidden')
    li.querySelector('.branch-edit-form').classList.remove('flex')
    li.querySelector('.branch-name-display').classList.remove('hidden')
    li.querySelector('.branch-edit-btn').classList.remove('hidden')
  }

  get branches(){
    return this.entriesTarget.getElementsByTagName("li").length
  }

}
